import { render, staticRenderFns } from "./profile-logos.vue?vue&type=template&id=21e5abfc&"
import script from "./profile-logos.vue?vue&type=script&lang=js&"
export * from "./profile-logos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports